import React, { useState, useEffect } from "react";

const durationOptions = [
  "More than 1 year",
  "3 months to 1 year", 
  "2 weeks to 3 months",
  "Less than 2 weeks"
];

const DurationQuestion = ({ onSubmit, onNext, initialValue }) => {
  const [selectedDuration, setSelectedDuration] = useState("");

  // Set initial value when editing
  useEffect(() => {
    if (initialValue) {
      setSelectedDuration(initialValue);
    }
  }, [initialValue]);

  const handleDurationChange = (duration) => {
    setSelectedDuration(duration);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!selectedDuration) return;
    
    onSubmit(selectedDuration);
    onNext();
    
    // Reset selection
    setSelectedDuration("");
  };

  const canSubmit = selectedDuration !== "";

  return (
    <form onSubmit={handleSubmit} className="input-form">
      <div className="duration-options-container">
        <div className="duration-options">
          {durationOptions.map((option) => (
            <button
              key={option}
              type="button"
              className={`duration-button ${selectedDuration === option ? 'duration-button-selected' : ''}`}
              onClick={() => handleDurationChange(option)}
            >
              {option}
            </button>
          ))}
        </div>
        <button
          type="submit"
          className="duration-submit-button"
          disabled={!canSubmit}
        >
          Continue
        </button>
      </div>
    </form>
  );
};

export default DurationQuestion;
